function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  className: "slideRight_svg__Thumbnail_Pro slideRight_svg__Gallery slideRight_svg__Animations_Overlay_Slide slideRight_svg__Right"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#80B1FF",
  d: "M21 31h-6.04c-.55 0-1-.45-1-1s.45-1 1-1H21c.55 0 1 .45 1 1s-.45 1-1 1zm1 5c0-.55-.45-1-1-1H11c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1zm0 6c0-.55-.45-1-1-1h-6.04c-.55 0-1 .45-1 1s.45 1 1 1H21c.55 0 1-.45 1-1zm4-15v18c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2V27c0-1.1-.9-2-2-2H28c-1.1 0-2 .9-2 2z",
  className: "slideRight_svg__illus-clr-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D6E6FF",
  d: "M46.49 40h-15c-.81 0-1.28-.85-.81-1.47l3.17-4.14c.36-.47 1.08-.52 1.51-.12l2.49 2.33 2.89-4.17c.38-.55 1.21-.58 1.63-.06l4.91 6.07c.51.63.04 1.56-.79 1.56z",
  className: "slideRight_svg__illus-clr-3"
}));

function SvgSlideRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='72' height='72' fill='none' viewBox='0 0 72 72'%3E %3Cg class='Thumbnail_Pro Gallery Animations_Overlay_Slide Right'%3E %3Cpath fill='%2380B1FF' d='M21 31h-6.04c-.55 0-1-.45-1-1s.45-1 1-1H21c.55 0 1 .45 1 1s-.45 1-1 1Zm1 5c0-.55-.45-1-1-1H11c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1Zm0 6c0-.55-.45-1-1-1h-6.04c-.55 0-1 .45-1 1s.45 1 1 1H21c.55 0 1-.45 1-1Zm4-15v18c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2V27c0-1.1-.9-2-2-2H28c-1.1 0-2 .9-2 2Z' class='illus-clr-1'/%3E %3Cpath fill='%23D6E6FF' d='M46.49 40h-15c-.81 0-1.28-.85-.81-1.47l3.17-4.14c.36-.47 1.08-.52 1.51-.12l2.49 2.33 2.89-4.17c.38-.55 1.21-.58 1.63-.06l4.91 6.07c.51.63.04 1.56-.79 1.56Z' class='illus-clr-3'/%3E %3C/g%3E %3C/svg%3E";
export { SvgSlideRight as ReactComponent };